// import React, { useState, useEffect } from "react";
import image1 from "../assets/Chaney.JPG";
import image2 from "../assets/Chelsea.JPG";
import image3 from "../assets/Courtney.JPG";
import image4 from "../assets/Teyana.JPG";
// import image5 from "../assets/Stacey ID.png";
import { Link } from "react-router-dom";

// const TeamSkeleton = () => (
//   <div className="w-full max-w-[340px] p-6 rounded-[3rem] border border-neutral-100 bg-white animate-pulse">
//     {/* Portrait Placeholder */}
//     <div className="aspect-[4/5] bg-neutral-100 rounded-[2.2rem] mb-8" />
    
//     {/* Text Placeholders */}
//     <div className="px-2 space-y-4">
//       <div className="h-6 bg-neutral-100 rounded w-3/4" />
//       <div className="h-3 bg-neutral-100 rounded w-1/2" />
//       <div className="space-y-2">
//         <div className="h-3 bg-neutral-50 rounded w-full" />
//         <div className="h-3 bg-neutral-50 rounded w-5/6" />
//       </div>
//     </div>
//   </div>
// );

const team = [
  { 
    name: "Chaney Pietersen", 
    role: "Founder | CEO",  
    expertise: ["Strategic Leadership", "Female Entrepreneurship", "Business Mentorship"], 
    image: image1 
  },
  { 
    name: "Chelsea Kolkoto", 
    role: "Co-Founder | Brand Director", 
    expertise: ["Digital Strategy", "Visual Identity", "Content Optimization"], 
    image: image2 
  },
  { 
    name: "Courtney Carelse", 
    role: "Co-Founder | Events Director", 
    expertise: ["Logistics Management", "Vendor Sourcing", "Event Delivery"], 
    image: image3 
  },
  { 
    name: "Teyana Raubenheimer", 
    role: "IT Director | Application Developer", 
    expertise: ["Technical Architecture", "Web Development", "UI/UX Systems"], 
    image: image4 
  },
  // { 
  //   name: "Anastacia Pienaar", 
  //   role: "Public Relations Officer | Communications Lead", 
  //   expertise: ["Public Relations", "Customer Service", "Recruitment"], 
  //   image: image5 
  // },
];

export default function OurTeam() {

  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   // Simulates assets loading for 1.5 seconds for a premium reveal
  //   const timer = setTimeout(() => setLoading(false), 1500);
  //   return () => clearTimeout(timer);
  // }, []);
  
  return (
    <div className="min-h-screen w-full bg-white flex flex-col items-center overflow-x-hidden">
    <section className="relative z-10 pt-32 pb-24 px-6 w-full max-w-7xl mx-auto">
        
    {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16 justify-items-center transition-all duration-1000">
          {loading 
            ? // Show 5 Skeletons while loading
              Array(5).fill(0).map((_, i) => <TeamSkeleton key={i} />)
            : // Reveal actual team cards
              team.map((member, index) => (
                <div key={index} className="opacity-0 animate-fadeIn h-full">
                </div>
              ))
          }
        </div> */}

        {/* Faded Background Heading */}
        <div className="absolute top-10 left-1/2 -translate-x-1/2 pointer-events-none opacity-[0.03] select-none">
          <h1 className="text-[15vw] font-['Playfair_Display'] whitespace-nowrap uppercase">Collective</h1>
        </div>

        {/* Heading Section */}
        <div className="text-center mb-20 relative z-10">
          <span className="text-[10px] uppercase tracking-[0.5em] text-pink-400 font-bold mb-4 block">The Creative Force</span>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-normal text-gray-900 tracking-tight leading-tight">
            Meet Our <span className="italic">Team</span>
          </h2>
          <div className="w-12 h-[1px] bg-neutral-200 mx-auto mt-10" />
        </div>

        {/* 💎 Uniform Team Gallery */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 justify-items-center">

          {team.map((member, index) => (
            <div
              key={index}
              className={`
                glass-card-glow group relative w-full max-w-[340px] p-6 rounded-[3rem] 
                transition-all duration-700 ease-[cubic-bezier(0.23,1,0.32,1)]
                hover:-translate-y-4 hover:shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1)]
                flex flex-col h-auto min-h-[650px]"
                /* Ensures all cards in a row match height */
              
              `}
            >
              {/* 🌀 Internal Background Animation */}
              <div className="absolute inset-0 z-0 opacity-15 group-hover:opacity-40 transition-opacity duration-700 pointer-events-none">
                 <div className="absolute top-1/2 left-1/2 w-[250%] h-[250%] -translate-x-1/2 -translate-y-1/2 blur-[50px] animate-rotate"
                      style={{ background: 'conic-gradient(from 0deg, #ff9aa2, #ffb7b2, #ffdac1, #e2f0cb, #a2e4ff, #c9afff, #ffb7b2, #ff9aa2)' }} />
              </div>

              {/* Portrait Container - Uniform Height */}
              <div className="relative z-10 aspect-[4/5] overflow-hidden rounded-[2.2rem] mb-8 shadow-sm">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 transition-all duration-1000 ease-out group-hover:scale-105"
                />
              </div>

              {/* Information Block */}
              <div className="relative z-10 px-2 pb-2 ">
                <h3 className="font-['Playfair_Display'] text-2xl text-gray-900 mb-2 tracking-wide">
                  {member.name}
                </h3>
                <div className="flex items-center gap-3 mb-5">
                   <div className="h-[1px] w-4 bg-pink-300" />
                   <p className="text-[10px] uppercase tracking-[0.3em] text-pink-400 font-bold">
                    {member.role}
                   </p>
                </div>
                <p className="text-[13px] text-neutral-500 leading-relaxed font-light">
                  {member.description}
                </p>
              </div>

             {/* Expertise Footer */}
      <div className="relative z-10 pt-6 border-t border-neutral-100 mt-auto">
        <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-300 font-bold mb-4">Expertise Focus</p>
        <div className="flex flex-wrap gap-y-2 gap-x-4">
          {member.expertise.map((skill) => ( // No more .split(" ")
            <span key={skill} className="text-[11px] text-neutral-600 italic border-r border-neutral-200 pr-4 last:border-none last:pr-0 whitespace-nowrap">
              {skill}
            </span>
          ))}
        </div>
      </div>
    

              {/* Decorative Icon */}
              {/* <div className="absolute top-8 right-8 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="w-8 h-8 rounded-full bg-white/50 backdrop-blur-md flex items-center justify-center text-[10px] text-pink-500 shadow-sm">✧</div>
              </div> */}
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-20">
        <Link to="/team-biography" className= "luxuryButton2">
              Learn More About Us
            </Link>
            </div>
      </section>
    </div>
  );
}